import styled from "styled-components";
// import LinkHandler from "./../LinkHandler";

// Shared properies, container
const StyledCardContainer = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  align-items: center;
  height: 100%;
  width: 100%;
`;

const StyledCardContainerOverlay = styled.div`
  display: flex;
  flex-direction: column;
  flex: 1 1 auto;
  align-items: center;
  position: relative;
`;

const StyledCardAuthorImage = styled.div`
  width: ${({ width }) => (width !== undefined ? width + "px" : "")};
  padding: 2px;
  display: flex;
  justify-content: center;
  align-items: center;
  border: 2px solid #ba9e5e;
  border-radius: 100%;
  overflow: hidden;
  img {
    border-radius: 100%;
  }
  &:hover {
    cursor: pointer;
  }
`;

const StyledCardAuthorImageOverlay = styled.div`
  padding: 2px;
  display: flex;
  justify-content: center;
  align-items: center;
  border: 2px solid #ba9e5e;
  border-radius: 100%;
  width: 100px;
  overflow: hidden;
  margin-top: -54px;
  img {
    border-radius: 100%;
  }
  z-index: 1;
`;

const StyledCardImage = styled.div``;

const StyledCardText = styled.div`
  display: flex;
  flex-direction: column;
  flex: 1 1 auto;
  justify-content: center;
  align-items: center;
`;

export {
  StyledCardContainer,
  StyledCardContainerOverlay,
  StyledCardImage,
  StyledCardText,
  StyledCardAuthorImage,
  StyledCardAuthorImageOverlay,
};
